import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
// Stores the location of previous Y coordinates for observed elements
const previousYArray = {};
// Stores the location of previous ratios for observed elements
const previousRatioArray = {};
export const TabNavigation = ({ resultList, sectionRefs }) => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('');
    const activeTabRef = useRef('');
    activeTabRef.current = activeTab;
    const [tabOrder, setTabOrder] = useState([]);
    const tabOrderRef = useRef([]);
    tabOrderRef.current = tabOrder;
    const observerCallback = (entries) => {
        const tabChanges = [];
        entries.forEach((entry) => {
            var _a;
            const currentY = entry.boundingClientRect.y;
            const currentRatio = entry.intersectionRatio;
            const isIntersecting = entry.isIntersecting;
            const targetId = ((_a = entry.target) === null || _a === void 0 ? void 0 : _a.getAttribute('id')) || '';
            const targetTabOrder = tabOrderRef.current.indexOf(targetId);
            const previousY = previousYArray[targetId] || 0;
            const previousRatio = previousRatioArray[targetId] || 0;
            if (currentY < previousY) {
                // scrolling down
                if (currentRatio > previousRatio && isIntersecting) {
                    // Target is entering the screen from the bottom
                    tabChanges.push(targetId);
                }
            }
            else if (currentY > previousY) {
                // scrolling up
                if (currentRatio > previousRatio && isIntersecting) {
                    // target is entering screen from the top
                    tabChanges.push(targetId);
                }
                else if (activeTabRef.current === targetId) {
                    // target is leaving screen from the bottom
                    tabChanges.push(tabOrderRef.current[targetTabOrder - 1]);
                }
            }
            // Save current components y position and ratio so we can use these the determine the scrolling direction
            previousYArray[targetId] = currentY;
            previousRatioArray[targetId] = currentRatio;
        });
        // In case of multiple intersections, choose the first one in the array
        if (tabChanges.length > 0) {
            setActiveTab(tabChanges[0]);
        }
    };
    useEffect(() => {
        setTabOrder(resultList.map(resultGroup => resultGroup.groupName));
        setActiveTab(resultList[0].groupName);
    }, [resultList]);
    useEffect(() => {
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 1
        };
        const observer = new IntersectionObserver(observerCallback, observerOptions);
        sectionRefs.forEach(ref => observer.observe(ref));
        return () => observer.disconnect();
    }, [sectionRefs]);
    if (!resultList.length) {
        return null;
    }
    return (React.createElement("div", { className: "tab-navigation" }, resultList.map(({ groupName, students }) => (React.createElement("a", { className: activeTab === groupName ? 'active' : undefined, onClick: () => scrollTo(groupName), key: groupName },
        t(`results.groups.${groupName}.navigation`),
        " (",
        students.length,
        ")")))));
};
const scrollTo = (elementId) => {
    const element = document.getElementById(elementId);
    const header = document.querySelector('.tab-navigation');
    if (!element || !header)
        return;
    let scrollPoint = element.getBoundingClientRect().top + window.scrollY - 20;
    scrollPoint -= header.getBoundingClientRect().height;
    window.scrollTo({ top: scrollPoint, behavior: 'auto' });
};
//# sourceMappingURL=tab-navigation.js.map